// oCe = Only Curls Enhancing
// oCeM = only Curls Enhancing Mousse
// oCm = Only Curls Mega
// oCmM = only Curls Mega Mousse

let searchParams = new URLSearchParams(decodeURIComponent(document.location.search));
let resultCode = searchParams.get("result");
let goalCodes = searchParams.get("curl-goals");
let hairType = searchParams.get("hair-type");
let username = searchParams.get("name");


goalCodes.split(',').forEach(goalCode => {
  goalCode = goalCode.trim().replaceAll(" ", "-").toLowerCase()
  
  document.querySelectorAll(`.${goalCode.trim().toLowerCase()}`).forEach(item => {
      item.classList.add('show-flex') 
  })  
})

document.querySelectorAll(`.${hairType}`).forEach(item => {
    item.classList.add('show-flex')
})

document.querySelectorAll(`.${resultCode.toLowerCase()}`).forEach(item => {
  item.classList.contains('flex') ? 
    item.classList.add('show-flex') 
    : item.classList.add('show-block')
  
  if (item.querySelector('.section-count')) {
    item.querySelector('.section-count').classList.add('active')
  }
})



if (username) {
  document.querySelector('#result-name-string').innerHTML = `${username}'s Hair Report:`
}

document.querySelectorAll('.section-count.active').forEach((item, idx) => {
  item.innerHTML = `Step ${idx + 1}`
})
